import * as React from 'react';
import { requireMap } from '../Map';
require('./assets/autocomplete.css');


const { useEffect, useState } = React;

export interface AutocompleteProps {
  inputId?: string;
  style?: any;
  value?: string;
  onChange?: (e: any) => any;
  onSelect?: (value: any) => any;
}

function Autocomplete(props: AutocompleteProps) {
  const { inputId, style, value } = props;
  const [scriptLoaded, setScriptLoaded] = useState(false);

  // 加载地图脚本
  useEffect(() => {
    requireMap(
      () => {
        setScriptLoaded(true);
      },
    );
    return () => {
      if ((Map as any).map) {
        if (name) {
          (((Map as any).map as any)[name] as AMap.Map).destroy();
          delete (Map as any).map[name];
        } else {
          ((Map as any).map as AMap.Map).destroy();
          delete (Map as any).map;
        }
      }
    };
  }, []);

  useEffect(() => {
    if (!scriptLoaded || !(window as any).AMap || !(window as any).AMap.Autocomplete) {
      return;
    }

    // 输入提示
    const auto = new (window as any).AMap.Autocomplete({
      input: inputId,
    });
    (window as any).AMap.event.addListener(auto, 'select', (e: any) => {
      const {
        name, address, district, location,
      } = e.poi;
      const mapResult = {
        name,
        address,
        district,
        location,
      };
      if (props.onSelect) {
        props.onSelect(mapResult);
      }
    });
  }, [(window as any).AMap, scriptLoaded]);

  const handleInput = (e: any) => {
    if (props.onChange) {
      props.onChange(e);
    }
  };

  return (
    <input
      className = 'autocompleteInput'
      autoComplete='off'
      id = { inputId }
      style = { style }
      value = { value || '' }
      onChange = { handleInput }
    />
  );
}

export default Autocomplete;
